module.exports = __webpack_public_path__ + "img/梧州banner-不可点击-固定-迅捷压缩.e745f1d1.png";